import { SuggestedAction } from '@common/interfaces/legalDocument'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'legal'

const LIST_DOCUMENTS = createRequestTypes(prefix, 'LIST_DOCUMENTS')
const PARSE_LEGAL_DOCUMENT = createRequestTypes(prefix, 'PARSE_LEGAL_DOCUMENT')
const GET_REDLINES = createRequestTypes(prefix, 'GET_REDLINES')
const GET_DOCUMENT_BUFFER = createRequestTypes(prefix, 'GET_DOCUMENT_BUFFER')
const UPDATE_REDLINE = createRequestTypes(prefix, 'UPDATE_REDLINE')
const UPDATE_REDLINES_BULK = createRequestTypes(prefix, 'UPDATE_REDLINES_BULK')
const DELETE_DOCUMENT = createRequestTypes(prefix, 'DELETE_DOCUMENT')
const ADD_REDLINE_COMMENT = createRequestTypes(prefix, 'ADD_REDLINE_COMMENT')
const APPLY_CHANGES = createRequestTypes(prefix, 'APPLY_CHANGES')

export const [LIST_DOCUMENTS_REQUEST, LIST_DOCUMENTS_SUCCESS, LIST_DOCUMENTS_FAILURE] =
  LIST_DOCUMENTS
export const [
  PARSE_LEGAL_DOCUMENT_REQUEST,
  PARSE_LEGAL_DOCUMENT_SUCCESS,
  PARSE_LEGAL_DOCUMENT_FAILURE,
] = PARSE_LEGAL_DOCUMENT
export const [GET_REDLINES_REQUEST, GET_REDLINES_SUCCESS, GET_REDLINES_FAILURE] = GET_REDLINES
export const [
  GET_DOCUMENT_BUFFER_REQUEST,
  GET_DOCUMENT_BUFFER_SUCCESS,
  GET_DOCUMENT_BUFFER_FAILURE,
] = GET_DOCUMENT_BUFFER
export const [UPDATE_REDLINE_REQUEST, UPDATE_REDLINE_SUCCESS, UPDATE_REDLINE_FAILURE] =
  UPDATE_REDLINE
export const [
  UPDATE_REDLINES_BULK_REQUEST,
  UPDATE_REDLINES_BULK_SUCCESS,
  UPDATE_REDLINES_BULK_FAILURE,
] = UPDATE_REDLINES_BULK
export const [DELETE_DOCUMENT_REQUEST, DELETE_DOCUMENT_SUCCESS, DELETE_DOCUMENT_FAILURE] =
  DELETE_DOCUMENT
export const [
  ADD_REDLINE_COMMENT_REQUEST,
  ADD_REDLINE_COMMENT_SUCCESS,
  ADD_REDLINE_COMMENT_FAILURE,
] = ADD_REDLINE_COMMENT
export const [APPLY_CHANGES_REQUEST, APPLY_CHANGES_SUCCESS, APPLY_CHANGES_FAILURE] = APPLY_CHANGES

export const listDocuments = createAction((id: string) => ({
  type: LIST_DOCUMENTS,
  promise: (api: IApi) => api.legal.listDocuments(id),
  id,
}))

export const parseLegalDocument = (id: string, formData: FormData) => ({
  type: PARSE_LEGAL_DOCUMENT,
  promise: (api: IApi) => api.legal.parseLegalDocument(id, formData),
  params: { id, formData },
})

export const getRedlines = createAction(
  (
    id: string,
    fileId: string,
    params?: {
      page?: number
      perPage?: number
      // Explicit offset; the server prefers it over page * perPage because a page can
      // come back longer than perPage when a concept group runs past the boundary.
      skip?: number
      section?: string
      loadMore?: boolean
      resolutionFilter?: 'resolved' | 'unresolved'
      skipLoader?: boolean
    },
  ) => ({
    type: GET_REDLINES,
    promise: (api: IApi) => api.legal.getRedlines(id, fileId, params),
    params,
  }),
)

export const getDocumentBuffer = createAction((id: string, fileId: string) => ({
  type: GET_DOCUMENT_BUFFER,
  promise: (api: IApi) => api.legal.getDocumentBuffer(id, fileId),
  params: { id, fileId },
}))

export const updateRedline = createAction(
  (
    id: string,
    fileId: string,
    redlineId: string,
    action: SuggestedAction | null,
    modifiedText?: string,
  ) => ({
    type: UPDATE_REDLINE,
    promise: (api: IApi) => api.legal.updateRedline(id, fileId, redlineId, action, modifiedText),
    params: { id, fileId, redlineId, action, modifiedText },
  }),
)

export const updateRedlinesBulk = createAction(
  (id: string, fileId: string, redlineIds: string[], action: SuggestedAction | null) => ({
    type: UPDATE_REDLINES_BULK,
    promise: (api: IApi) => api.legal.updateRedlinesBulk(id, fileId, redlineIds, action),
    params: { id, fileId, redlineIds, action },
  }),
)

export const deleteDocument = createAction((id: string, fileId: string) => ({
  type: DELETE_DOCUMENT,
  promise: (api: IApi) => api.legal.deleteDocument(id, fileId),
  params: { id, fileId },
}))

export const addRedlineComment = createAction(
  (id: string, fileId: string, redlineId: string, comment: string | null) => ({
    type: ADD_REDLINE_COMMENT,
    promise: (api: IApi) => api.legal.addRedlineComment(id, fileId, redlineId, comment),
    params: { id, fileId, redlineId, comment },
  }),
)

export const applyChanges = createAction((id: string, fileId: string) => ({
  type: APPLY_CHANGES,
  promise: (api: IApi) => api.legal.applyChanges(id, fileId),
}))
